function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-16 -14) translate(16 14)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00CFBF",
  fillRule: "nonzero",
  d: "M10.286 14.649c-.003.152-.025 1.887-.064 5.204-.022 2.473.075 4.13.292 4.969.152.59.52 1.1 1.105 1.531.585.431 1.191.647 1.82.647.346 0 .66-.08.942-.238.39-.227.607-.67.65-1.328.087-1.066.13-1.61.13-1.633 1.885-6.49 2.99-9.666 3.315-9.53.151.045.227.862.227 2.45 0 .318-.01.874-.032 1.668v1.982c.006 2.818.169 4.472.487 4.961.607.908 1.538 1.362 2.795 1.362.996 0 1.635-.42 1.917-1.26.087-.25.13-.465.13-.646 0-.386-.217-.755-.65-1.106-.433-.352-.65-.653-.65-.902-.022-6.49-.022-11.119 0-13.887-.065-1.044-.964-1.566-2.697-1.566-.932 0-1.636.182-2.112.545-.369.272-.91 1.566-1.625 3.88-.91 3.04-1.538 4.97-1.885 5.786l.065-7.352c0-.204.092-.46.276-.765.184-.307.266-.755.244-1.345-.022-.567-.471-1.055-1.349-1.463C12.74 6.204 11.868 6 11.001 6c-.563 0-.964.113-1.202.34-.238.227-.417.488-.536.783-.12.295-.244.59-.374.885-1.061 2.201-1.917 4.016-2.567 5.446v-3.88c0-.25.103-.568.309-.953.206-.386.308-.681.308-.885 0-.159-.032-.318-.097-.477C6.56 6.533 5.715 6.17 4.307 6.17c-1.148 0-1.863.227-2.145.68-.108.182-.162.375-.162.58 0 .204.076.51.227.918.152.409.239.727.26.953v8.033c.044 2.745.239 4.402.585 4.97.239.385.623.73 1.154 1.037.53.306 1.056.46 1.576.46.477 0 .856-.125 1.137-.375.282-.25.38-.714.293-1.395-.087-.794-.076-1.328.032-1.6.13-1.27.64-2.859 1.528-4.765.368-.794.801-1.622 1.3-2.484.108.022.173.51.195 1.463v-.003.007z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 3.5,
  r: 2.9,
  fill: "#FFF",
  stroke: "#00CEBF",
  strokeWidth: 1.2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 4.5,
  r: 1.5,
  fill: "#000"
}))));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.f8cf6e9a.svg";
export { ForwardRef as ReactComponent };